/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ language: NonNullable<unknown> }} Remove_LanguageInputs */



/**
* | output |
* | --- |
* | "Remove {language}" |
*
* @param {Remove_LanguageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const remove_language = /** @type {((inputs: Remove_LanguageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remove_LanguageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Supprimer ${i?.language}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Entferne ${i?.language}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Rimuovi ${i?.language}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Удалить ${i?.language}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Eliminar ${i?.language}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`移除${i?.language}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.language} を削除`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.language} को हटाएँ`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Remover ${i?.language}`)
	return /** @type {LocalizedString} */ (`Remove ${i?.language}`)
});